import Client4 from "../../client/client4";
const client = new Client4();



/**
 * @param  {} updateRender
 * @param  {} type
 * Получить список всех доступных изображений
 */
export const getImagesCollection = (updateRender, type) => {
  return (
    Object.keys(updateRender).reduce((acc, rootKey) => {
      let rootParts = updateRender[rootKey].parts

      if (!rootParts) {
        return acc;
      }

      const partsArray = Object.keys(rootParts);
      let images = [];
      for (let key of partsArray) {
        const materialName = rootParts[key].materialValue;

        const sortPostition = rootParts[key].position;
        let renderValue = (updateRender[rootKey]).value;

        //todo: Причина этой странности в том, что ряд элементов при отсутсвии имеют аттрибут None
        if (renderValue === 'pocketNone') {
          continue;
        }

        let subKey = key;

        /* 
          todo: Это костыль обусловлен внезапным появлением 24 новых элементов.
        */
        if (updateRender.cuffStyle.value == 'cuffStyleStraight' && rootKey == 'cuff') {
          renderValue += '_a';
        }

        if (updateRender.cuffStyle.value == 'cuffStyleTruncated' && rootKey == 'cuff') {
          renderValue += '_b';
        }

        if (updateRender.cuffStyle.value == 'cuffStyleRound' && rootKey == 'cuff') {
          renderValue += '_c';
        }

        if (updateRender.cuffStyle.value == 'cuffStyleOriginal' && rootKey == 'cuff') {
          renderValue += '_d';
        }

        if (updateRender.fastening.value == 'fasteningStandard' && rootKey == 'body') {
          renderValue += 'standart';
        }

        if (updateRender.fastening.value == 'fasteningStandardBone' && rootKey == 'body') {
          renderValue += 'standart';
        }

        if (updateRender.fastening.value == 'fasteningHidden' && rootKey == 'body') {
          renderValue += 'hidden';
        }

        if (updateRender.fastening.value == 'fasteningPlank' && rootKey == 'body') {
          renderValue += 'planked';
        }

        if (updateRender.fastening.value == 'fasteningSmoking' && rootKey == 'body') {
          renderValue += 'tuxedo';
        }

        if(rootKey === 'pocket') {
        // if (renderValue === 'pocketLeftRound' || renderValue === 'pocketLeftV') {
          renderValue = 'pocketLeft';
        }

        const sizePrefix = {
          preview: 'b',
          builder: 's',
          xsmall: 'xs',
        }

        const imgUrl = `${client.getBaseCatalogImageUrl()}/renders/${renderValue}/${subKey}/${materialName}_${sizePrefix[type]}.png`;

        images.push({
          src: imgUrl.toLowerCase(),
          sortPostition,
        })
      }

      return acc.concat(...images)
    }, []).sort((a, b) => {
      return a.sortPostition - b.sortPostition;
    })
  )
}



/**
 * @param  {} img
 * @param  {} canvas
 * Получить смещение по горизонтали для центрирования изображения в Cavas
 */
export const horizontalOffset = (img, canvas) => (canvas.width - img.width) / 2

/**
 * @param  {} img
 * @param  {} canvas
 * Получить смещение по вертикали для центрирования изображения в Cavas
 */
export const verticalOffset = (img, canvas) => (canvas.height - img.height) / 2